import { Component, Inject, OnDestroy } from '@angular/core';
import { TokenExpiredConfig } from '@pv-frontend/authentication';
import {
  PV_USER_SERVICE,
  PvUserService,
} from '@pv-frontend/pv-shared-services/pv-user-service';
import { Subject, takeUntil } from 'rxjs';

import { appConstants } from './app.constants';

@Component({
  selector: 'midday-root',
  templateUrl: './app.component.html',
  styleUrls: [],
})
export class AppComponent implements OnDestroy {
  public title = appConstants.title;
  private destroy$: Subject<void> = new Subject<void>();
  public tokenExpiredModuleConfig?: Partial<TokenExpiredConfig>;
  public showTokenExpiredModal = false;
  public toastBreakpoints: Record<string, Record<string, string>> = {
    '1024px': { right: '0' },
  };

  public constructor(
    @Inject(PV_USER_SERVICE) private pvUserService: PvUserService
  ) {
    this.showTokenExpiredModal =
      !window.location.pathname.includes('sso_login') &&
      this.pvUserService.isTokenExpired();
    if (this.showTokenExpiredModal) this.pvUserService.updateTokenExpiry(true);
  }

  public subscribeToLogin(): void {
    this.pvUserService.loginModalObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (showLoginModal: boolean) => {
          if (showLoginModal) {
            this.pvUserService.toggleAuthModal(true);
          }
        },
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
